import { createSharedPathnamesNavigation } from 'next-intl/navigation'

import { OMS_LOCALES } from './constants'

export const {
  Link: NextLink,
  redirect,
  usePathname,
  useRouter,
} = createSharedPathnamesNavigation({
  locales: OMS_LOCALES,
})
